<footer>
  <div class="footer-content">
    <div class="footer-section">
      <h4>Shop</h4>
      <ul class="footer-links">
        <li><a routerLink="/products">All Products</a></li>
        <li><a routerLink="/new-in">New Arrivals</a></li>
        <li><a routerLink="/brands">Brands</a></li>
        <li><a routerLink="/clearance">Sale & Clearance</a></li>
      </ul>
    </div>
    <div class="footer-section">
      <h4>Features</h4>
      <ul class="footer-links">
        <li><a routerLink="/mix-match">Mix & Match</a></li>
        <li><a routerLink="/wishlist">My Wishlist</a></li>
        <li><a routerLink="/products">Size Guide</a></li>
        <li><a routerLink="/products">Reviews</a></li>
      </ul>
    </div>
    <div class="footer-section">
      <h4>Support</h4>
      <ul class="footer-links">
        <li><a routerLink="/contact">Contact Us</a></li>
        <li><a href="#">Returns & Exchanges</a></li>
        <li><a href="#">Shipping Info</a></li>
        <li><a href="#">FAQ</a></li>
      </ul>
    </div>
    <div class="footer-section">
      <h4>Follow Us</h4>
      <div class="social-links">
        <a href="#" class="social-link"><i class="pi pi-facebook"></i></a>
        <a href="#" class="social-link"><i class="pi pi-twitter"></i></a>
        <a href="#" class="social-link"><i class="pi pi-instagram"></i></a>
        <a href="#" class="social-link"><i class="pi pi-youtube"></i></a>
      </div>
    </div>
  </div>
  <div class="footer-bottom">
    <p>&copy; 2024 Zodi. All rights reserved.</p>
  </div>
</footer>
